import { useState } from 'react';
import { useBlankActions } from '../useBlankActions';
import { Button, Icon, Sheet } from '@gravity-ui/uikit';
import { CirclePlus, EllipsisVertical } from '@gravity-ui/icons';
import { BlankBlockMenu } from './blank-block-menu';
import { BlankBlockSheetMenu } from './sheets';
import styles from './styles.module.scss';

export const AdaptiveBlankBlock = ({ person, selectedIds, handleSelect, dateString, refetch, role, isMobile }: any) => {
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [visible, setVisible] = useState(false);

	const { isDeleting, handleDeleteBlank, handleDownloadBlank, handleEditBlank, handleAddRating } =
		useBlankActions(refetch);

	const isSelected = selectedIds.includes(person.id as number);

	return (
		<div key={person.id} className={`${styles.list_block} ${isSelected ? styles.list_block__selected : ''}`}>
			<div className={styles.list_block__panel}>
				<label>
					<input
						type="checkbox"
						checked={selectedIds.includes(person.id as number)}
						onChange={(e) => handleSelect(person.id as number, e.target.checked)}
					/>
				</label>

				{isMobile ? (
					<>
						<Button view="flat" onClick={() => setVisible(true)}>
							<Icon data={EllipsisVertical} size={16} />
						</Button>
						<BlankBlockSheetMenu
							visible={visible}
							setVisible={setVisible}
							person={person}
							handleAddRating={handleAddRating}
							handleEditBlank={handleEditBlank}
							handleDownloadBlank={handleDownloadBlank}
							setOpenDeleteModal={setOpenDeleteModal}
							isDeleting={isDeleting}
							openDeleteModal={openDeleteModal}
							handleDeleteBlank={handleDeleteBlank}
						/>
					</>
				) : (
					<BlankBlockMenu
						person={person}
						handleAddRating={handleAddRating}
						handleEditBlank={handleEditBlank}
						handleDownloadBlank={handleDownloadBlank}
						setOpenDeleteModal={setOpenDeleteModal}
						isDeleting={isDeleting}
						openDeleteModal={openDeleteModal}
						handleDeleteBlank={handleDeleteBlank}
					/>
				)}
			</div>

			<div className={styles.list_block__user}>
				<div className={styles.list_block__user__info}>
					{role === 'SPECIALIST' ? <h3>Имя клиета</h3> : <h3>ID</h3>}
					<p>
						{role === 'SPECIALIST'
							? `${person.lastName} ${person.firstName} ${person.middleName}`
							: person.id}
					</p>
				</div>

				<div className={styles.list_block__user__info}>
					<h3>Учреждение</h3>
					<p>{person.establishment?.name ?? '—'}</p>
				</div>

				<div className={styles.list_block__user__info}>
					<h3>Дата</h3>
					<p> {dateString}</p>
				</div>
			</div>
			{isMobile ? (
				<>
					<Button view="outlined" onClick={() => handleAddRating(person.id)} size="l">
						<Icon data={CirclePlus} size={16} />
						Добавить оценку
					</Button>
					<Button view="outlined" onClick={() => handleAddRating(person.id)} size="l">
						Подробнее
					</Button>
				</>
			) : (
				''
			)}
		</div>
	);
};
